import { DatePipe, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  Injector,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { LottieAnimationViewModule } from 'ng-lottie';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GridListComponentModule } from './components/grid-list/grid-list.component.module';
import { InputCalendarioComponentModule } from './components/input-calendario/input-calendario.component.module';
import { LocalidadeUfMunicipioComponentModule } from './components/localidade-uf-municipio/localidade-uf-municipio.component.module';
import { LocalidadeComponentModule } from './components/localidade/localidade.component.module';
import { ModalAlertaComponent } from './components/modal-alerta/modal-alerta.component';
import { ModalDesativacaoReativacaoComponent } from './components/modal-desativacao-reativacao/modal-desativacao-reativacao.component';
import { ModalExportarComponent } from './shared/components/modal-exportar/modal-exportar.component'; 
import { ModalListAcoesGridComponent } from './components/modal-list-acoes-grid/modal-list-acoes-grid.component';
import { ModalLoaderComponent } from './components/modal-loader/modal-loader.component';
import { ModalResponderSolicitacaoComponent } from './components/modal-responder-solicitacao/modal-responder-solicitacao.component';
import { SelecaoFiltroModule } from './components/selecao-filtro/selecao-filtro.module';
import { SelecaoPesquisaPageModule } from './components/selecao-pesquisa/selecao-pesquisa.module';
import { TrocarLocalidadeComponentModule } from './components/trocar-localidade/trocar-localidade.component.module';
import { TrocarPerfilComponentModule } from './components/trocar-perfil/trocar-perfil.module';
import { ValidationInputComponentModule } from './components/validation-input/validation-input.module';
import { GestureConfig } from './config/gesture-config';
import { ModalMensagemHorizontalPage } from './pages/estabelecimentos/painel-estabelecimento/modal/modal-mensagem-horizontal/modal-mensagem-horizontal.page';
import { ModalAcoesListComponent } from './pages/estabelecimentos/rascunhos/modal-acoes-list/modal-acoes-list.component';
import { ModalCarregandoComponent } from './pages/gestor/shared/components/modal-carregando/modal-carregando.component';
import { ModalResponderSolicitacaoPage } from './pages/gestor/solicitacoes-desligamento/modal/modal-responder-solicitacao/modal-responder-solicitacao.page';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PROVIDERS } from './providers';
import { CnesErrorHandler } from './providers/error.handler';
import { BaseService } from './services/base.service';
import { BrowserBaseService } from './services/browser-base.service';
import { AuthorizationInterceptor } from './services/interceptors/authorization.interceptor';
import { AvisoOperacaoInterceptor } from './services/interceptors/aviso-operacao.interceptor';
import { LoaderService } from './services/loader.service';
import { effects, metaReducers, reducers } from './store';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    ModalAcoesListComponent,
    ModalAlertaComponent,
    ModalLoaderComponent,
    ModalExportarComponent,
    ModalListAcoesGridComponent,
    ModalCarregandoComponent,
    ModalDesativacaoReativacaoComponent,
    ModalResponderSolicitacaoComponent,
    ModalResponderSolicitacaoPage,
    ModalMensagemHorizontalPage,
  ],
  entryComponents: [
    ModalAcoesListComponent,
    ModalAlertaComponent,
    ModalLoaderComponent,
    ModalExportarComponent,
    ModalListAcoesGridComponent,
    ModalCarregandoComponent,
    ModalDesativacaoReativacaoComponent,
    ModalResponderSolicitacaoComponent,
    ModalResponderSolicitacaoPage,
    ModalMensagemHorizontalPage,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot({
      rippleEffect: true,
      mode: 'md',
    }),
    AppRoutingModule,
    IonicStorageModule.forRoot({
      name: 'MS_CNES_1.0',
    }),
    BrowserAnimationsModule,
    SelecaoPesquisaPageModule,
    SelecaoFiltroModule,
    TrocarLocalidadeComponentModule,
    TrocarPerfilComponentModule,
    LocalidadeComponentModule,
    LocalidadeUfMunicipioComponentModule,
    GridListComponentModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
    LottieAnimationViewModule.forRoot(),
    ValidationInputComponentModule,
    ReactiveFormsModule,
    InputCalendarioComponentModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
    }),
    EffectsModule.forRoot(effects),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
  ],
  providers: [
    StatusBar,
    PROVIDERS,
    DatePipe,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: BaseService, useClass: BrowserBaseService },
    { provide: ErrorHandler, useClass: CnesErrorHandler },
    { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig },
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AvisoOperacaoInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  static injector: Injector;

  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
